import { render, staticRenderFns } from "./UserApi.vue?vue&type=template&id=e28aceec&scoped=true"
import script from "./UserApi.vue?vue&type=script&lang=js"
export * from "./UserApi.vue?vue&type=script&lang=js"
import style0 from "./UserApi.vue?vue&type=style&index=0&id=e28aceec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28aceec",
  null
  
)

export default component.exports